import React from "react";

import { createGetServerSideProps } from "utils/createGetServerSideProps";

import NotificationSettings from "components/UserProfile/Settings/Notifications";
import PasswordSettings from "components/UserProfile/Settings/Password";
import UserProfileLayout from "components/UserProfile/UserProfileLayout";

const SettingsPage: React.FC = () => {
  return (
    <UserProfileLayout currentPage="Settings">
      <h2>Settings</h2>
      <div className="row my-lg">
        <NotificationSettings className="col md:col-1/2 mb-xl" />
        <PasswordSettings className="col md:col-1/2" />
      </div>
    </UserProfileLayout>
  );
};

export const getServerSideProps = createGetServerSideProps();

export default SettingsPage;
